module.exports = __webpack_public_path__ + "static/img/6.16d7c47.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/zh/6.png
// module id = /uB7
// module chunks = 0